<template>
  <section class="relative">
    <div>

      <img
        src="@/assets/svg/empty-tank.svg"
        v-if="capacity <= 0"
        class="w-[9.74rem]"
      />
      <img
        src="@/assets/svg/black-tank.svg"
        v-if="capacity > 0 && capacity < 30"
      />

      <img src="@/assets/svg/green-tank.svg" v-if="capacity > 30" />
    </div>
    <div
      v-if="showLabel"
      class="z-50 px-3 text-[8px] font-semibold text-white uppercase w-fit bg-estationsGreen-400 absolute top-12 left-8"
    >
      {{ product }}
    </div>
  </section>
</template>

<script>
export default {
  name: "Tank",
  props: {
    capacity: {
      type: Number,
      default: 0,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    product: {
      type: String,
      default: "Product",
    },
  },
};
</script>

<style></style>
